import React, { useEffect, useMemo, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { extractTableHeaders } from 'utils/hooks/reportTableUtils';
import { BProps, DataTypeB0103 } from 'store/ducks/Reportings/types';
import { columnsB0103 } from 'constants/reportColumns';

const B0103: React.FC<BProps> = ({ entityName }) => {
  const { date, is_displayed } = useSelector(
    (state: RootState) => state.reportings,
  );

  const [data, setData] = useState<DataTypeB0103[]>([]);
  const memoizedColumns = useMemo(() => columnsB0103, [columnsB0103]);
  const dispatch = useDispatch();
  const fetchData = async () => {
    dispatch(set_isDisplayed(false));
    const entityIds: string[] = entityName
      ? entityName.split(',').map((id) => id.trim())
      : [];

    const params = {
      entityId: entityIds,
      date,
    };

    try {
      const fetchedData = await reportingOp.fetchBranches(params);

      if (fetchedData && fetchedData.entities) {
        const allEntities = Object.values(fetchedData.entities).flat();
        const date = fetchedData.date;
        const formattedData = allEntities.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: dataItem.entity_name,
            branch_identification_code: dataItem.branch_identification_code,
            branch_name: dataItem.branch_name,
            country_id: dataItem.country_code?.slice(0, 2) ?? '',
            head_office_lei: dataItem.head_office_lei,
            entity_id: dataItem.entity_id,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_displayed, entityName]);

  useEffect(() => {
    extractTableHeaders(memoizedColumns, dispatch);
  }, []);

  return (
    <>
      <Table
        columns={columnsB0103}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default B0103;
